import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const SettingPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeadLayout title={t("navigation.settings")}></HeadLayout>
      <div className="p-4 bg-background rounded-lg">
        <Outlet />
      </div>
    </>
  );
};

export default SettingPage;
